export default __webpack_public_path__ + "static/media/logo-mobile.09182fb7.svg";